import { ISite } from './ISite';
import { SiteEnum } from '../../models/enums/SiteEnum';
export class SiteSciencedysten implements ISite {
    backgroundImageName: string = 'background_sciencedysten.png';
    redirectTilNvHus: boolean = false;
    kortNavn: string = 'SD';
    navn: string = 'Sciencedysten';
    type: SiteEnum = SiteEnum.Sciencedysten;
    logoName: string = 'sd-logo.png';
    stortLogoName: string = 'sd-logo-stort.png';
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/site/SiteScienceDysten.ts